var React = require('react');

function TroubleshootIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m19.437 10 9.717 9.717-5.608 5.609-2.73-2.729h.001l-1.414-1.414-1.415-1.414-1.414-1.414-2.746-2.746L19.438 10zm-4.277 9.769-2.746-2.746a2 2 0 0 1 0-2.829l5.609-5.608a2 2 0 0 1 2.828 0l2.871 2.87a3.001 3.001 0 0 1 3.993 3.994l2.854 2.853a2 2 0 0 1 0 2.828l-5.61 5.61a2 2 0 0 1-2.828 0l-2.728-2.73-6.282 6.282A3 3 0 1 1 8.88 26.05l6.281-6.281zm1.414 1.414-6.281 6.282a1 1 0 0 0 0 1.414l-.707.707.707-.707a1 1 0 0 0 1.414 0l.643.642-.643-.642 6.281-6.282-1.414-1.414z","fill":"#fff"}));
}

TroubleshootIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = TroubleshootIcon;

TroubleshootIcon.default = TroubleshootIcon;
